import React from 'react'

function Contact() {
  return (
    <div className='d-flex justify-content-center mt-3' style={{color:"#565387"}}><h1><strong>CONTACT US</strong></h1></div>
  )
}

export default Contact